import * as actionTypes from './actionTypes';
import { openModal } from '@app/src/commons/modal/state/modals/actions';
import { servicePassword } from './services';

const fetchCreatePasswordRequest = () => ({
  type: actionTypes.FETCH_CREATEPASSWORD_REQUEST
});

const fetchCreatePasswordFailure = (errorMessage) => ({
  type: actionTypes.FETCH_CREATEPASSWORD_FAILURE,
  errorMessage
});

const fetchCreatePasswordSuccess = (data) => ({
  type: actionTypes.FETCH_CREATEPASSWORD_SUCCESS,
  data
});

export const fetchCreatePassword = (value, url): Function => {
  return async dispatch => {
    dispatch(fetchCreatePasswordRequest());
    const { password } = value;
    const token = window.location.pathname.split('/').pop();
    try {
      const data = await servicePassword.getData({password, token}, url);
      dispatch(fetchCreatePasswordSuccess(data));
      dispatch(openModal('CREATE_PASSWORD_SUCCESS_MODAL'));
    } catch (error) {
      if (error.code === 146) {
        dispatch(fetchCreatePasswordFailure(error.message));
        dispatch(openModal('CREATE_PASSWORD_ERROR_MODAL'));
        return;
      }
      dispatch(fetchCreatePasswordFailure('Ocurrió un error, por favor vuelve a intentar.'));
      dispatch(openModal('CREATE_PASSWORD_ERROR_MODAL'));
    }
  }
};
